import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataFieldComponentBase } from './datafield-base-component';
import { XPathComponent } from 'src/app/controls/components/advanced/xpath/xpath.component';

@Component({
  selector: 'ep-datafield-xpath',
  templateUrl: './datafield-xpath.component.html',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
  // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
  outputs: ['valueChanged'], // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, XPathComponent]
})
export class DatafieldXpathComponent extends DataFieldComponentBase {

  constructor() {
    super();
  }

  valueChange(): void {
    this.formValidationGroup.controls[this.validationIdentifier].patchValue(this.datafield.Value);
    this.notifyValueChanged(this.datafield);
  }

  get isValid() {
    if (this.formValidationGroup.disabled) {
      return true;
    }

    return this.formValidationGroup.controls[this.validationIdentifier].valid;
  }

  get errorText() {
    if (this.formValidationGroup.disabled) {
      return '';
    }

    if (this.formValidationGroup.controls[this.validationIdentifier].hasError('required')) {
      return 'This field is required';
    }

    if (this.formValidationGroup.controls[this.validationIdentifier].hasError('pattern')) {
      return this.datafield.RegExErrorMessage || `Invalid pattern - must match: ${this.datafield.RegEx}`; // If not error-message is given - use a generic error message...
    }

    return 'Unknown error';
  }
}
